import ImageSelector from "@/modules/common/components/input/image-selector";
import { useTrackDocumentQuery } from "@/modules/property-tracks/hooks/track-document.hook";
import { ResaleDocumentsFormFields } from "@/modules/property-tracks/utils/listing";
import { Box, FormHelperText, Typography } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";

interface ResaleDocumentsFormProps {
  form: UseFormReturn<ResaleDocumentsFormFields>;
  trackUid: string;
}

export default function ResaleDocumentsForm({
  form,
  trackUid,
}: ResaleDocumentsFormProps) {
  const { data: floorPlans, isLoading: floorPlansLoading } =
    useTrackDocumentQuery({
      uid: trackUid,
      documentType: "FloorPlans",
    });

  const { data: images, isLoading: imagesLoading } = useTrackDocumentQuery({
    uid: trackUid,
    documentType: "Media",
  });

  return (
    <Box
      sx={(t) => ({
        display: "flex",
        flexDirection: "column",
        gap: t.nawy.spacing.md,
      })}
    >
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        Media
      </Typography>
      <Controller
        control={form.control}
        name={"floorPlanUids"}
        render={({ field, fieldState }) => {
          return (
            <Box>
              <Typography
                sx={(t) => t.nawy.typography.english.variants.body.xs.regular}
              >
                Select floor plan images
              </Typography>

              <ImageSelector
                images={floorPlans ?? []}
                loading={floorPlansLoading}
                selectedImagesIds={field.value ?? []}
                setSelectedImagesIds={(ids: string[]) => field.onChange(ids)}
              />
              {fieldState.error && (
                <FormHelperText error>
                  {fieldState.error.message}
                </FormHelperText>
              )}
            </Box>
          );
        }}
      ></Controller>
      <Controller
        control={form.control}
        name={"mediaUids"}
        render={({ field, fieldState }) => {
          return (
            <Box>
              <Typography
                sx={(t) => t.nawy.typography.english.variants.body.xs.regular}
              >
                Select gallery images
              </Typography>

              <ImageSelector
                images={images ?? []}
                loading={imagesLoading}
                selectedImagesIds={field.value ?? []}
                setSelectedImagesIds={(ids: string[]) => field.onChange(ids)}
              />
              {fieldState.error && (
                <FormHelperText error>
                  {fieldState.error.message}
                </FormHelperText>
              )}
            </Box>
          );
        }}
      ></Controller>
    </Box>
  );
}
